import React, { useEffect, useState } from "react";
import { GdanskSaleForm } from "../../../models/GdanskSaleForm";
import EAMultipleChoiceChipSelector from "../../shared/ChoiceChip/EAMultipleChoiceChipSelector";
import { get } from "../../../api";
import { GET_COLORS } from "../../../api/apiRoutes";
import useFacility from "../../../../utils/hooks/useFacility";
import getId from "../../../../utils/getId";
import { AssortGroup } from "../../../models/AssortGroup";
interface IProps {
  form: GdanskSaleForm;
  setForm: (form: GdanskSaleForm) => void;
}

const GdanskColorInput: React.FC<IProps> = ({ form, setForm }) => {
  const facilityIds = useFacility();
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState<{ value: string; label: string }[]>([]);

  const getColors = async () => {
    setLoading(true);
    const { result, isError } = await get(GET_COLORS(facilityIds));
    if (!isError) {
      const newResult = result.map((item: AssortGroup) => ({ value: getId(item), label: item.name }));
      setOptions(newResult);
    }
    setLoading(false);
  };

  useEffect(() => {
    getColors();
    //eslint-disable-next-line
  }, []);

  return (
    <div className="gdansk-input-content">
      <h5 className="no-line-height">Wybierz rodzaj niecki</h5>
      <EAMultipleChoiceChipSelector
        options={options ?? []}
        selectedValue={form.colorIds}
        onSelect={(value, label) => setForm({ ...form, colorIds: value, colorName: label })}
        chipSize="small"
        loading={loading}
        width="70%"
      />
    </div>
  );
};

export default GdanskColorInput;
